var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 210,
    viewBox: "0 0 273 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.5,
    cy: 173.5,
    rx: 129.5,
    ry: 36.5,
    fill: "#E3E3E3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.5,
    cy: 163.5,
    rx: 129.5,
    ry: 36.5,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.523 128.272H119.07V17.417H256.523V128.272V128.272ZM120 127.342H255.593V18.347H120V127.342Z",
    fill: "#C6C4C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.165 63.3591H195.235V62.8011H196.165V63.3591ZM196.165 60.9411H195.235V58.1512H196.165V60.9411ZM196.165 56.2912H195.235V53.5012H196.165V56.2912ZM196.165 51.6412H195.235V48.8512H196.165V51.6412ZM196.165 46.9912H195.235V44.2013H196.165V46.9912ZM196.165 42.3413H195.235V39.5513H196.165V42.3413ZM196.165 37.6913H195.235V34.9013H196.165V37.6913ZM196.165 33.0413H195.235V30.2514H196.165V33.0413ZM256.057 30.6234H253.267V29.6934H256.057V30.6234ZM251.407 30.6234H248.617V29.6934H251.407V30.6234ZM246.757 30.6234H243.967V29.6934H246.757V30.6234ZM242.107 30.6234H239.317V29.6934H242.107V30.6234ZM237.457 30.6234H234.667V29.6934H237.457V30.6234ZM232.807 30.6234H230.017V29.6934H232.807V30.6234ZM228.157 30.6234H225.367V29.6934H228.157V30.6234ZM223.507 30.6234H220.717V29.6934H223.507V30.6234ZM218.857 30.6234H216.067V29.6934H218.857V30.6234ZM214.207 30.6234H211.417V29.6934H214.207V30.6234ZM209.557 30.6234H206.767V29.6934H209.557V30.6234ZM204.907 30.6234H202.117V29.6934H204.907V30.6234ZM200.257 30.6234H197.467V29.6934H200.257V30.6234Z",
    fill: "#C6C4C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.386 68.1951H241.085V38.5283H246.386V68.1951ZM241.922 67.2651H245.363V39.4583H241.922V67.2651Z",
    fill: "#C6C4C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.574 68.1939H233.273V46.2461H238.574V68.1939ZM234.11 67.2639H237.551V47.1761H234.11V67.2639Z",
    fill: "#C6C4C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230.762 68.1955H225.461V56.4775H230.762V68.1955ZM226.391 67.2655H229.832V57.4075H226.391V67.2655Z",
    fill: "#C6C4C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.627 161.754H45.2279V56.1998C45.2279 52.2938 48.3899 49.1318 52.2959 49.1318H205.652C209.558 49.1318 212.72 52.2938 212.72 56.1998V161.754H212.627Z",
    fill: "#6C63FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.489 56.9443H51.2728V157.663H206.489V56.9443Z",
    fill: "#E7E6FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.489 152.733H51.2728V157.662H206.489V152.733Z",
    fill: "#E7E7E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1527 152.733H51.2728V157.662H66.1527V152.733Z",
    fill: "#425666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4558 154.314H54.0629V156.081H63.4558V154.314Z",
    fill: "#748C9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M225.089 170.123H32.673C29.604 170.123 27 167.612 27 164.45V161.66H230.669V164.45C230.762 167.612 228.251 170.123 225.089 170.123Z",
    fill: "#3C3B4B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.503 161.754H107.258V165.846H150.503V161.754Z",
    fill: "#617688"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.008 84.3789H94.0522V125.857H177.008V84.3789Z",
    fill: "#D8D8D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.008 84.3789H94.0522V92.1908H177.008V84.3789Z",
    fill: "#EF069A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2602 86.9824H96.6562V89.5864H99.2602V86.9824Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.468 86.9824H101.864V89.5864H104.468V86.9824Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.676 86.9824H107.072V89.5864H109.676V86.9824Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.269 107.721H114.792V110.325H156.269V107.721Z",
    fill: "#EF069A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M156.269 115.533H114.792V118.137H156.269V115.533Z",
    fill: "#EF069A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.269 99.9102H114.791V102.514H156.269V99.9102Z",
    fill: "#EF069A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1067 74.4283H60.9447C59.1777 74.4283 57.7827 73.0333 57.7827 71.2663V68.1044C57.7827 66.3374 59.1777 64.9424 60.9447 64.9424H64.1067C65.8737 64.9424 67.2686 66.3374 67.2686 68.1044V71.2663C67.2686 73.0333 65.8737 74.4283 64.1067 74.4283Z",
    fill: "#EF069A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1068 89.4H60.9448C59.1778 89.4 57.7828 88.005 57.7828 86.238V83.076C57.7828 81.309 59.1778 79.9141 60.9448 79.9141H64.1068C65.8738 79.9141 67.2688 81.309 67.2688 83.076V86.238C67.2688 88.005 65.8738 89.4 64.1068 89.4Z",
    fill: "#6C63FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1067 104.373H60.9447C59.1777 104.373 57.7827 102.978 57.7827 101.211V98.0487C57.7827 96.2817 59.1777 94.8867 60.9447 94.8867H64.1067C65.8737 94.8867 67.2686 96.2817 67.2686 98.0487V101.211C67.2686 102.978 65.8737 104.373 64.1067 104.373Z",
    fill: "#01B187"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1067 119.253H60.9447C59.1777 119.253 57.7827 117.858 57.7827 116.091V112.929C57.7827 111.162 59.1777 109.767 60.9447 109.767H64.1067C65.8737 109.767 67.2686 111.162 67.2686 112.929V116.091C67.2686 117.858 65.8737 119.253 64.1067 119.253Z",
    fill: "#425666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 19,
    width: 82,
    height: 61,
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.185 0H225.592V74.4925H272.185V0Z",
    fill: "#6C63FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.535 4.64941H225.592V69.8419H267.535V4.64941Z",
    fill: "#E7E6FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M225.593 0H179V74.4925H225.593V0Z",
    fill: "#7F77FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M225.593 4.64941H183.65V69.8419H225.593V4.64941Z",
    fill: "#E7E6FC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M193.043 37.2921C195.611 37.2921 197.693 35.2103 197.693 32.6422C197.693 30.074 195.611 27.9922 193.043 27.9922C190.475 27.9922 188.393 30.074 188.393 32.6422C188.393 35.2103 190.475 37.2921 193.043 37.2921Z",
    fill: "#6C63FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M204.668 37.2921C207.236 37.2921 209.318 35.2103 209.318 32.6422C209.318 30.074 207.236 27.9922 204.668 27.9922C202.1 27.9922 200.018 30.074 200.018 32.6422C200.018 35.2103 202.1 37.2921 204.668 37.2921Z",
    fill: "#01B187"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M216.292 37.2921C218.861 37.2921 220.942 35.2103 220.942 32.6422C220.942 30.074 218.861 27.9922 216.292 27.9922C213.724 27.9922 211.642 30.074 211.642 32.6422C211.642 35.2103 213.724 37.2921 216.292 37.2921Z",
    fill: "#EF069A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M262.885 16.2744H230.242V18.5994H262.885V16.2744Z",
    fill: "#3A4D57"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M262.885 23.25H230.242V25.575H262.885V23.25Z",
    fill: "#3A4D57"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M262.885 30.3174H230.242V32.6424H262.885V30.3174Z",
    fill: "#3A4D57"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M262.885 37.291H230.242V39.616H262.885V37.291Z",
    fill: "#3A4D57"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M262.885 44.2666H230.242V46.5916H262.885V44.2666Z",
    fill: "#3A4D57"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M253.492 51.2422H230.242V53.5672H253.492V51.2422Z",
    fill: "#3A4D57"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M253.492 58.2178H230.242V60.5428H253.492V58.2178Z",
    fill: "#3A4D57"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M221.036 44.2666H188.393V46.5916H221.036V44.2666Z",
    fill: "#3A4D57"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M221.036 51.2422H188.393V53.5672H221.036V51.2422Z",
    fill: "#3A4D57"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M221.036 58.2178H188.393V60.5428H221.036V58.2178Z",
    fill: "#3A4D57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/BE.29e882b5d358405ecf801a4c80e1c41f.svg";
export { ForwardRef as ReactComponent };